import getDefaultReminder from 'owa-calendar-forms-common/lib/utils/getDefaultReminder';
import getDefaultStart from 'owa-calendar-forms-common/lib/utils/getDefaultStart';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import initializeCalendarEvent from 'owa-calendar-forms-common/lib/utils/initializeCalendarEvent';
import { now } from 'owa-datetime';

/**
 * Initializes a new CalendarEvent based on current time
 */
export default function initializeNewCalendarEvent(): CalendarEvent {
    return initializeCalendarEvent({
        Start: getDefaultStart(now()),
        ReminderMinutesBeforeStart: getDefaultReminder(false),
    } as CalendarEvent);
}
